module.exports = "/images/play-icon.svg?6b57fe9cc91e3733088cddf0355d434e";